import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import moment from 'moment';
import { Row, Col, Form, Button, Pagination, Card } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import Header from '~/Components/Header/Header';
import { default as Selector } from 'react-select';
import DateMask from '~/Components/DateMask';
import MaskedInput from 'react-text-mask';
import * as constants from '~/constant';
import { useSelector } from 'react-redux';
import Loading from '~/Components/Loading';
import { toast } from 'react-toastify';
import {
  FaSearch,
  FaFileExcel,
  FaPlus,
  FaMinus,
  FaFileContract,
} from 'react-icons/fa';
import AuthStorage from '~/Utils/AuthStorage';
import * as api from '~/Services/Service';
import { salvarEmExcel, createDate } from '~/Utils/Helpers';
import ModalDetalhesDocDigital from '~/Components/DocumentoDigital/ModalDetalhesDocDigital';

const ControleDocumentoDigital = () => {
  const empreendimentos = useSelector(state => state.empreendimentos);
  const [loading, setLoading] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [retornoApi, setRetornoApi] = useState([]);
  const [recordsPerPage] = useState(20);
  const [habilitarMaisFiltros, setHabilitarMaisFiltros] = useState(false);
  const [realizandoDownload, setRealizandoDownload] = useState(false);
  const [modoMobile, setModoMobile] = useState(window.innerWidth <= 768);
  const [mostrarModalDetalhes, setMostrarModalDetalhes] = useState(false);

  const gruposPendenteSetpar = {
    PendenteAssinaturaTestemunha: '6,2',
    PendenteAssinaturaProcurador: '6,3',
  };

  useEffect(() => {
    if (window.innerWidth <= 770) {
      setModoMobile(true);
      return;
    }
    setModoMobile(false);
  }, [window.innerWidth]);

  const abrirModalDetalhes = () => {
    setMostrarModalDetalhes(true);
  };

  const validationSchema = Yup.object().shape({
    data_inicial: Yup.string()
      .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Formato de data inválido')
      .test('valid-date', 'Data inválida', value => {
        if (!value) return true;
        return moment(value, 'DD/MM/YYYY', true).isValid();
      })
      .test('data-inicial-require-pair', 'Preencha a data final', function(
        value
      ) {
        const { data_final } = this.parent;
        if (value && !data_final) {
          return false;
        }
        return true;
      }),
    data_final: Yup.string()
      .matches(/^\d{2}\/\d{2}\/\d{4}$/, 'Formato de data inválido')
      .test('valid-date', 'Data inválida', value => {
        if (!value) return true;
        return moment(value, 'DD/MM/YYYY', true).isValid();
      })
      .test('data-final-require-pair', 'Preencha a data inicial', function(
        value
      ) {
        const { data_inicial } = this.parent;
        if (value && !data_inicial) {
          return false;
        }
        return true;
      })
      .test(
        'data-final-great-than-inicial',
        'A data final deve ser maior que a data inicial',
        function(value) {
          const { data_inicial } = this.parent;
          if (!data_inicial) {
            return true;
          }
          if (
            moment(value, 'DD/MM/YYYY').isAfter(
              moment(data_inicial, 'DD/MM/YYYY')
            )
          ) {
            return true;
          }
          return false;
        }
      ),
  });

  const temPermissao = AuthStorage.temCaracteristica(
    constants.caracteristicas.ConsultaDocDigital
  );

  const optionsEmpreendimentos = [
    { value: '', label: 'Todos empreendimentos' },
    ...empreendimentos.sort.map(item => ({
      value: item.codigo,
      label: item.codigo + ' - ' + item.descricao,
    })),
  ];

  const habilitarDesabilitarFiltros = () => {
    setHabilitarMaisFiltros(!habilitarMaisFiltros);
  };

  const handleSort = column => {
    let direction = 'asc';
    if (sortConfig.key === column && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key: column, direction });
  };

  const totalPages = Math.ceil(retornoApi.length / recordsPerPage);
  const sortedRetornoApi = React.useMemo(() => {
    if (sortConfig.key) {
      const sorted = [...retornoApi].sort((a, b) => {
        const valA = a[sortConfig.key];
        const valB = b[sortConfig.key];

        if (valA === null && valB === null) return 0;
        if (valA === null) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valB === null) return sortConfig.direction === 'asc' ? 1 : -1;

        if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
        if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
        return 0;
      });
      return sorted;
    }
    return retornoApi;
  }, [retornoApi, sortConfig]);

  const currentRecords = React.useMemo(() => {
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    return sortedRetornoApi.slice(indexOfFirstRecord, indexOfLastRecord);
  }, [sortedRetornoApi, currentPage, recordsPerPage]);

  const buscarDocumentosD4sign = async filtro => {
    try {
      setLoading(true);
      let auxFiltros = { ...filtro };

      if (filtro.status === gruposPendenteSetpar.PendenteAssinaturaProcurador) {
        auxFiltros.status = 6;
        auxFiltros.grupo_signatario_pendente_setpar = 3;
      } else if (
        auxFiltros.status === gruposPendenteSetpar.PendenteAssinaturaTestemunha
      ) {
        auxFiltros.status = 6;
        auxFiltros.grupo_signatario_pendente_setpar = 2;
      }

      var filtroLimpo = Object.fromEntries(
        Object.entries(auxFiltros).filter(
          ([_, value]) => value !== '' && value !== null && value !== undefined
        )
      );

      if (filtroLimpo.data_inicial) {
        filtroLimpo.data_inicial = createDate(
          filtroLimpo.data_inicial,
          'DD/MM/YYYY'
        ).format(constants.DATE_FORMAT_SERVER);
        filtroLimpo.data_final = createDate(
          filtroLimpo.data_final,
          'DD/MM/YYYY'
        ).format(constants.DATE_FORMAT_SERVER);
      }

      const retornoApi = await api.pesquisarDocumentosD4sign(filtroLimpo);
      setRetornoApi(retornoApi);
    } catch (error) {
      toast.error(error.message || 'Erro ao buscar Documentos da D4sign');
    } finally {
      setLoading(false);
    }
  };

  const handleRowClick = item => {
    setSelectedRow(item);
  };

  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber);
  };

  const abrirTelaSituacaoCliente = cpf => {
    window.open('/cliente/pesquisa/situacao/' + cpf, '_blank');
  };

  const montarLinkDocDigital = async (pre_venda, codigo) => {
    let codigoDoc = await api.obterCodigoDocDigital(pre_venda);
    if (codigoDoc === 0) {
      return '/documentodigital?codPreVenda=' + pre_venda;
    } else {
      return '/documentodigital?codDocDigital=' + codigo;
    }
  };

  return (
    <div>
      {temPermissao && (
        <div>
          <Header title="Controle Documento Digital" />
          <Formik
            initialValues={{
              nome_cliente: '',
              empreendimento: '',
              data_inicial: '',
              data_final: '',
              ge: '',
              conta: '',
              quadra: '',
              lote: '',
              tipo_doc_digital: '',
              nome_solicitante: '',
              departamento_solicitante: '',
              grupo_pendente: '',
              assinatura_pendente: '',
              pre_venda: '',
              status: '',
              motivo_cancelamento: '',
              aprovador: '',
              qtd_dias_aprovacao: '',
              procurador: '',
              dias_procurador: '',
              primeira_testemunha: '',
              qtd_dias_primeira_testemunha: '',
              segunda_testemunha: '',
              qtd_dias_segunda_testemunha: '',
              qtd_dias_clientes: '',
              total_dias: '',
            }}
            validationSchema={validationSchema}
            onSubmit={filtro => {
              buscarDocumentosD4sign(filtro);
            }}
          >
            {({ handleSubmit, setFieldValue, errors, values, touched }) => (
              <Form
                onSubmit={handleSubmit}
                className="container-fluid bg-white p-3"
              >
                <Row>
                  <Col xs={12} sm={6} md={4} lg={2}>
                    <Form.Group controlId="nome_cliente">
                      <small>Nome Cliente</small>
                      <Field
                        type="text"
                        name="nome_cliente"
                        className="form-control"
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={5} lg={3}>
                    <Form.Group controlId="empreendimento">
                      <small>Empreendimento</small>
                      <Selector
                        noOptionsMessage={() =>
                          'Nenhum empreendimento encontrado'
                        }
                        placeholder="Buscar..."
                        options={optionsEmpreendimentos}
                        onChange={selectedOption => {
                          setFieldValue(
                            'empreendimento',
                            selectedOption ? selectedOption.value : ''
                          );
                        }}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={4} lg={2}>
                    <DateMask
                      allowEmpty
                      onValidate={value => setFieldValue('data_inicial', value)}
                    >
                      {() => (
                        <Form.Group controlId="data_inicial">
                          <small>Data inicial</small>
                          <MaskedInput
                            name="data_inicial"
                            type="tel"
                            guide={false}
                            className={`form-control`}
                            placeholder="Ex.: 01/01/2019"
                            mask={constants.MASK_DATE}
                            value={values.data_inicial}
                            onChange={e => {
                              setFieldValue('data_inicial', e.target.value);
                            }}
                          />
                          <Form.Control.Feedback
                            className="d-flex"
                            type="invalid"
                          >
                            {errors && errors.data_inicial}
                          </Form.Control.Feedback>
                        </Form.Group>
                      )}
                    </DateMask>
                  </Col>
                  <Col xs={12} sm={6} md={4} lg={2}>
                    <DateMask
                      allowEmpty
                      onValidate={value => setFieldValue('data_final', value)}
                    >
                      {() => (
                        <Form.Group controlId="data_final">
                          <small>Data Final</small>
                          <MaskedInput
                            name="data_final"
                            type="tel"
                            guide={false}
                            className={`form-control`}
                            placeholder="Ex.: 01/01/2019"
                            mask={constants.MASK_DATE}
                            value={values.data_final}
                            onChange={e => {
                              setFieldValue('data_final', e.target.value);
                            }}
                          />
                          <Form.Control.Feedback
                            className="d-flex"
                            type="invalid"
                          >
                            {errors && errors.data_final}
                          </Form.Control.Feedback>
                        </Form.Group>
                      )}
                    </DateMask>
                  </Col>

                  <Col xs={12} sm={6} md={4} lg={2}>
                    <Form.Group controlId="ge">
                      <small>Grupo Empresa</small>
                      <Field type="number" name="ge" className="form-control" />
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={4} lg={1}>
                    <Form.Group controlId="conta">
                      <small>Codigo Conta</small>
                      <Field
                        type="number"
                        name="conta"
                        className="form-control"
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col xs={6} sm={6} md={2} lg={1}>
                    <Form.Group controlId="quadra">
                      <small>Quadra</small>
                      <Field
                        type="text"
                        name="quadra"
                        className="form-control"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6} sm={6} md={2} lg={1}>
                    <Form.Group controlId="lote">
                      <small>Lote</small>
                      <Field type="text" name="lote" className="form-control" />
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Group controlId="tipo_doc_digital">
                      <small>Tipo Documento</small>
                      <Field
                        as="select"
                        name="tipo_doc_digital"
                        className="form-control"
                      >
                        <option value="">Selecione...</option>
                        <option value="9">Autorização de Escritura</option>
                        <option value="10">
                          Autorização Transferência de Conta
                        </option>
                        <option value="11">
                          Cancelamento de Cessão de Direitos
                        </option>
                        <option value="8">
                          Cessão de Transferência de Cotas
                        </option>
                        <option value="2">CLBD</option>
                        <option value="12">Confissão de Dívida</option>
                        <option value="1">Contrato de Compra e Venda</option>
                        <option value="13">Lote de Apoio</option>
                        <option value="14">Recibo</option>
                        <option value="3">
                          Refinanciamento - Aditamento Contrato
                        </option>
                        <option value="5">Rescisão Bilateral</option>
                        <option value="4">Rescisão Repasse</option>
                        <option value="7">Rescisão Unilateral</option>
                        <option value="6">Transferência Titularidade</option>
                      </Field>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={4} lg={2}>
                    <Form.Group controlId="nome_solicitante">
                      <small>Solicitante</small>
                      <Field
                        type="text"
                        name="nome_solicitante"
                        className="form-control"
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Group controlId="departamento_solicitante">
                      <small>Departamento Solicitante</small>
                      <Field
                        as="select"
                        name="departamento_solicitante"
                        className="form-control"
                      >
                        <option value="">Selecione...</option>
                        <option value="30005">ADMINISTRAÇÃO PREDIAL</option>
                        <option value="31408">APL</option>
                        <option value="31201">ASSESSORIA PRESIDENCIA</option>
                        <option value="33408">BACK OFFICE</option>
                        <option value="30007">
                          CADASTROS E DÉBITOS MUNICIPAIS
                        </option>
                        <option value="33405">CAC POUSO ALEGRE</option>
                        <option value="33406">
                          CAC SÃO SEBASTIÃO DO PARAISO
                        </option>
                        <option value="33403">CAC SÃO JOSÉ DO RIO PRETO</option>
                        <option value="33404">CAC SÃO JOSÉ DOS CAMPOS</option>
                        <option value="31412">
                          CENTRAL PERFORMANCE DE VENDAS
                        </option>
                        <option value="31411">
                          CENTRAL DE ATENDIMENTO DE VENDAS
                        </option>
                        <option value="31202">CEO ST</option>
                        <option value="32202">CLDB</option>
                        <option value="31601">CONTABILIDADE</option>
                        <option value="31602">CONTROLADORIA</option>
                        <option value="31203">DIRETORIA STF, RT e BT</option>
                        <option value="31417">DNI NEGOCIOS IMOB</option>
                        <option value="31801">ENGENHARIA ADM RP</option>
                        <option value="30013">EXECUÇÃO FISCAL</option>
                        <option value="31416">FENIX NEGOCIOS IMOB</option>
                        <option value="32201">FINANCEIRO</option>
                        <option value="31419">GITECH</option>
                        <option value="32401">GENTE E GESTAO</option>
                        <option value="31810">MEIO AMBIENTE</option>
                        <option value="33409">PLANEJAMENTO E QUALIDADE</option>
                        <option value="33009">PROCESSOS e SUPORTE TI</option>
                        <option value="33201">JURIDICO CONTENCIOSO</option>
                        <option value="33203">JURIDICO NEGOCIAL</option>
                        <option value="31415">JH NEGOCIOS IMOB</option>
                        <option value="31409">R&A</option>
                        <option value="33401">
                          RELACIONAMENTO COM CLIENTE
                        </option>
                        <option value="31401">REVO BRASIL</option>
                        <option value="33402">RECEBÍVEIS</option>
                        <option value="31404">RHT</option>
                        <option value="31405">SGi</option>
                        <option value="31418">SGI NEGOCIOS IMOB</option>
                        <option value="31413">SECRETARIA DE VENDAS</option>
                        <option value="33004">Soluções Digitais</option>
                        <option value="33001">TI DESENVOLVIMENTO</option>
                        <option value="32802">URBANISMO</option>
                      </Field>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={4} lg={2}>
                    <Form.Group controlId="grupo_pendente">
                      <small>Grupo Pendente</small>
                      <Field
                        as="select"
                        name="grupo_pendente"
                        className="form-control"
                      >
                        <option value="">Selecione...</option>
                        <option value="1">COMPRADORES</option>
                        <option value="2">TESTEMUNHAS</option>
                        <option value="3">PROCURADORES</option>
                        <option value="4">VALIDADORES</option>
                        <option value="5">INTERVENIENTES</option>
                      </Field>
                    </Form.Group>
                  </Col>

                  <Col xs={12} sm={6} md={3} lg={2}>
                    <Form.Group controlId="assinatura_pendente">
                      <small>Assinatura Pendente</small>
                      <Field
                        type="text"
                        name="assinatura_pendente"
                        className="form-control"
                      ></Field>
                    </Form.Group>
                  </Col>
                </Row>
                {habilitarMaisFiltros && (
                  <>
                    <Row>
                      <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="pre_venda">
                          <small>Código Pré-Venda</small>
                          <Field
                            type="number"
                            name="pre_venda"
                            className="form-control"
                          ></Field>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="status">
                          <small>Status doc</small>
                          <Field
                            as="select"
                            name="status"
                            className="form-control"
                          >
                            <option value="">Selecione...</option>
                            <option value="2">Aprovado</option>
                            <option value="8">Ass. Finalizadas</option>
                            <option value="7">Cancelado</option>
                            <option value="4">Descartado</option>
                            <option value="11">Gravado</option>
                            <option value="10">Implantado</option>
                            <option value="5">
                              Pendente Assinatura Cliente
                            </option>
                            <option value="6,2">
                              Pendente Assinatura Testemunha
                            </option>
                            <option value="6,3">
                              Pendente Assinatura Procurador(a)
                            </option>
                            <option value="3">Reprovado</option>
                            <option value="1">Solicitado</option>
                            <option value="9">Carregado</option>
                          </Field>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="motivo_cancelamento">
                          <small>Motivo Cancelamento</small>
                          <Field
                            as="select"
                            name="motivo_cancelamento"
                            className="form-control"
                          >
                            <option value="">Selecione...</option>
                            <option value="8">
                              Alteração Cláusula Contratual
                            </option>
                            <option value="0">Compra e Venda</option>
                            <option value="6">Cliente Inadimplente</option>
                            <option value="7">
                              Condição de Venda Não Autorizada
                            </option>
                            <option value="1">Dados Errados</option>
                            <option value="9">
                              Dados do Contrato Incorreto
                            </option>
                            <option value="10">
                              Erro de Lançamento de Venda
                            </option>
                            <option value="13">Falta de Pagamento</option>
                            <option value="3">
                              Informações e/ou Ações Incorretas da Área
                            </option>
                            <option value="4">
                              Mudança ou Desistências da Negociação
                            </option>
                            <option value="2">Negociação Fora de Alçada</option>
                            <option value="5">Prazo Expirado</option>
                            <option value="12">Problema Sistêmatico</option>
                            <option value="11">
                              Solicitou Assinatura Física
                            </option>
                          </Field>
                        </Form.Group>
                      </Col>
                      <Col xs={12} sm={6} md={3} lg={1}>
                        <Form.Group controlId="qtd_dias_clientes">
                          <small>Dias Cliente{'(s)'}</small>
                          <Field
                            type="number"
                            name="qtd_dias_clientes"
                            className="form-control"
                          ></Field>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3} lg={1}>
                        <Form.Group controlId="total_dias">
                          <small>Dias Totais</small>
                          <Field
                            type="number"
                            name="total_dias"
                            className="form-control"
                          ></Field>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={4} lg={2}>
                        <Form.Group controlId="primeira_testemunha">
                          <small>1ª Testemunha</small>
                          <Field
                            type="text"
                            name="primeira_testemunha"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="qtd_dias_primeira_testemunha">
                          <small>Dias 1ª Testemunha</small>
                          <Field
                            type="number"
                            name="qtd_dias_primeira_testemunha"
                            className="form-control"
                          ></Field>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} sm={6} md={4} lg={2}>
                        <Form.Group controlId="segunda_testemunha">
                          <small>2ª Testemunha</small>
                          <Field
                            type="text"
                            name="segunda_testemunha"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="qtd_dias_segunda_testemunha">
                          <small>Dias 2ª Testemunha</small>
                          <Field
                            type="number"
                            name="qtd_dias_segunda_testemunha"
                            className="form-control"
                          ></Field>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={4} lg={2}>
                        <Form.Group controlId="aprovador">
                          <small>Aprovador</small>
                          <Field
                            type="text"
                            name="aprovador"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="qtd_dias_aprovacao">
                          <small>Dias Aprovador</small>
                          <Field
                            type="number"
                            name="qtd_dias_aprovacao"
                            className="form-control"
                          ></Field>
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={4} lg={2}>
                        <Form.Group controlId="procurador">
                          <small>Procurador{'(a)'}</small>
                          <Field
                            type="text"
                            name="procurador"
                            className="form-control"
                          />
                        </Form.Group>
                      </Col>

                      <Col xs={12} sm={6} md={3} lg={2}>
                        <Form.Group controlId="dias_procurador">
                          <small>Dias Procurador{'(a)'}</small>
                          <Field
                            type="number"
                            name="dias_procurador"
                            className="form-control"
                          ></Field>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
                <div className="d-flex justify-content-end align-itens-center">
                  <Button
                    variant="outline-primary"
                    type="button"
                    onClick={habilitarDesabilitarFiltros}
                    className="col-xs-12 col-sm-6 col-md-4 col-lg-1 mr-3"
                  >
                    {habilitarMaisFiltros ? <FaMinus /> : <FaPlus />}
                    <span className="d-xs-none"> Filtros</span>
                  </Button>

                  <Button
                    disabled={Object.values(errors).length > 0 || loading}
                    variant="success"
                    type="submit"
                    className="col-xs-12 col-sm-6 col-md-4 col-lg-1"
                  >
                    <FaSearch />
                    <span className="d-xs-none"> Buscar</span>
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
          {loading && <Loading />}
        </div>
      )}
      {!loading && currentRecords.length > 0 && (
        <div
          className={
            modoMobile ? 'container-fluid bg-white table-responsive' : ''
          }
        >
          {!modoMobile && (
            <div className="w-100 bg-white" style={{ maxWidth: '98vw' }}>
              <div className="col-md-12 table-responsive">
                <table className="table table-sm table-striped">
                  <thead>
                    <tr className="text-left font-size-14">
                      <th
                        onClick={() => handleSort('data_solicitacao')}
                        style={{ cursor: 'pointer' }}
                      >
                        Solicitação
                      </th>

                      <th
                        onClick={() => handleSort('codigo')}
                        style={{ cursor: 'pointer' }}
                      >
                        Código Doc.
                      </th>
                      <th style={{ cursor: 'pointer' }}>Doc. Digital</th>
                      <th
                        onClick={() => handleSort('status')}
                        style={{ cursor: 'pointer' }}
                      >
                        Status Doc.
                      </th>
                      <th
                        onClick={() => handleSort('motivo_cancelamento')}
                        style={{ cursor: 'pointer' }}
                      >
                        Motivo do Cancelamento
                      </th>
                      <th
                        onClick={() => handleSort('tipo_doc_digital')}
                        style={{ cursor: 'pointer' }}
                      >
                        Tipo
                      </th>
                      <th
                        onClick={() => handleSort('nome_cliente')}
                        style={{ cursor: 'pointer' }}
                      >
                        Cliente
                      </th>
                      <th
                        onClick={() => handleSort('ge')}
                        style={{ cursor: 'pointer' }}
                      >
                        GE
                      </th>
                      <th
                        onClick={() => handleSort('conta')}
                        style={{ cursor: 'pointer' }}
                      >
                        Conta
                      </th>
                      <th
                        onClick={() => handleSort('empreendimento')}
                        style={{ cursor: 'pointer' }}
                      >
                        Empreendimento
                      </th>
                      <th
                        onClick={() => handleSort('quadra')}
                        style={{ cursor: 'pointer' }}
                      >
                        Quadra
                      </th>

                      <th
                        onClick={() => handleSort('lote')}
                        style={{ cursor: 'pointer' }}
                      >
                        Lote
                      </th>

                      <th
                        onClick={() => handleSort('nome_solicitante')}
                        style={{ cursor: 'pointer' }}
                      >
                        Solicitante
                      </th>
                      <th
                        onClick={() => handleSort('departamento_solicitante')}
                        style={{ cursor: 'pointer' }}
                      >
                        Depto. Solicitante
                      </th>
                      <th
                        onClick={() => handleSort('grupo_pendente')}
                        style={{ cursor: 'pointer' }}
                      >
                        Grupo Pendente
                      </th>
                      <th
                        onClick={() => handleSort('assinatura_pendente')}
                        style={{ cursor: 'pointer' }}
                      >
                        Assinatura Pendente
                      </th>
                      <th
                        onClick={() => handleSort('pre_venda')}
                        style={{ cursor: 'pointer' }}
                      >
                        Pré-Venda
                      </th>

                      <th
                        onClick={() => handleSort('aprovador')}
                        style={{ cursor: 'pointer' }}
                      >
                        Aprovador
                      </th>

                      <th
                        onClick={() => handleSort('primeira_testemunha')}
                        style={{ cursor: 'pointer' }}
                      >
                        1ª Testemunha
                      </th>

                      <th
                        onClick={() => handleSort('segunda_testemunha')}
                        style={{ cursor: 'pointer' }}
                      >
                        2ª Testemunha
                      </th>

                      <th
                        onClick={() => handleSort('procurador')}
                        style={{ cursor: 'pointer' }}
                      >
                        Procurador(a)
                      </th>

                      <th
                        onClick={() => handleSort('dias_aprovador')}
                        style={{ cursor: 'pointer' }}
                      >
                        Qtd Dias Aprovador
                      </th>

                      <th
                        onClick={() =>
                          handleSort('qtd_dias_primeira_testemunha')
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        Qtd Dias 1ª Testemunha
                      </th>

                      <th
                        onClick={() =>
                          handleSort('qtd_dias_segunda_testemunha')
                        }
                        style={{ cursor: 'pointer' }}
                      >
                        Qtd Dias 2ª Testemunha
                      </th>

                      <th
                        onClick={() => handleSort('qtd_dias_procurador')}
                        style={{ cursor: 'pointer' }}
                      >
                        Qtd Dias Procurador(a)
                      </th>

                      <th
                        onClick={() => handleSort('qtd_dias_clientes')}
                        style={{ cursor: 'pointer' }}
                      >
                        Qtd Dias Cliente(s)
                      </th>

                      <th
                        onClick={() => handleSort('total_dias')}
                        style={{ cursor: 'pointer' }}
                      >
                        Qtd Total Dias
                      </th>
                    </tr>
                  </thead>
                  <tbody className="text-left font-size-13">
                    {currentRecords.length > 0 &&
                      currentRecords.map((item, index) => (
                        <tr
                          key={index}
                          style={{
                            fontWeight:
                              selectedRow === item ? 'bold' : 'normal',
                            cursor: 'pointer',
                            transition: 'background-color 0.1s ease',
                          }}
                          onClick={() => {
                            handleRowClick(item);
                          }}
                        >
                          <td>
                            {new Intl.DateTimeFormat('pt-BR').format(
                              new Date(item.data_solicitacao)
                            )}
                          </td>
                          <td>{item.codigo}</td>

                          <td
                            onClick={async () => {
                              let link = await montarLinkDocDigital(
                                item.pre_venda, item.codigo
                              );
                              if (link) {
                                window.open(link, '_blank');
                              }
                            }}
                          >
                            <FaFileContract size={18} />
                          </td>
                          <td>{item.status}</td>
                          <td>{item.motivo_cancelamento}</td>
                          <td>{item.tipo_doc_digital}</td>
                          <td
                            onClick={() => {
                              abrirTelaSituacaoCliente(item.cpf_cliente);
                            }}
                            style={{ textDecoration: 'underline' }}
                          >
                            {item.nome_cliente}
                          </td>
                          <td>{item.ge}</td>
                          <td>{item.conta}</td>
                          <td>{item.empreendimento}</td>

                          <td>{item.quadra}</td>
                          <td>{item.lote}</td>
                          <td>{item.nome_solicitante}</td>
                          <td>{item.departamento_solicitante}</td>
                          <td>{item.grupo_pendente}</td>
                          <td>{item.assinatura_pendente}</td>
                          <td>{item.pre_venda}</td>
                          <td>{item.aprovador}</td>
                          <td>{item.primeira_testemunha}</td>
                          <td>{item.segunda_testemunha}</td>
                          <td>{item.procurador}</td>
                          <td>{item.dias_aprovador}</td>
                          <td>{item.qtd_dias_primeira_testemunha}</td>
                          <td>{item.qtd_dias_segunda_testemunha}</td>
                          <td>{item.qtd_dias_procurador}</td>
                          <td>{item.qtd_dias_clientes}</td>
                          <td>{item.total_dias}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {modoMobile &&
            currentRecords.length > 0 &&
            currentRecords.map((item, index) => (
              <Card
                className="mt-2 border border-1 border-muted"
                key={index}
                style={{
                  fontWeight: selectedRow === item ? 'bold' : 'normal',
                  cursor: 'pointer',
                  backgroundColor: selectedRow === item ? '#f0f0f0' : 'white',
                }}
                onClick={() => handleRowClick(item)}
              >
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  <li className="m-1">
                    <small>Solicitação</small>
                    <strong className="d-block" style={{ fontSize: 'smaller' }}>
                      {new Intl.DateTimeFormat('pt-BR').format(
                        new Date(item.data_solicitacao)
                      )}
                    </strong>
                  </li>
                  <li
                    className="m-1"
                    onClick={() => {
                      abrirTelaSituacaoCliente(item.cpf_cliente);
                    }}
                  >
                    <small>Cliente</small>
                    <strong
                      className="d-block"
                      style={{
                        fontSize: 'smaller',
                        textDecoration: 'underline',
                      }}
                    >
                      {item.nome_cliente}
                    </strong>
                  </li>
                  <li className="m-1">
                    <small>GE/Conta</small>
                    <strong className="d-block" style={{ fontSize: 'smaller' }}>
                      {item.ge} / {item.conta}
                    </strong>
                  </li>
                </ul>
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  {item.empreendimento !== null && (
                    <li className="m-1">
                      <small>Empreendimento</small>
                      <strong className="d-block" style={{ fontSize: '11px' }}>
                        {item.empreendimento}
                      </strong>
                    </li>
                  )}
                  {item.quadra !== null && item.lote !== null && (
                    <li className="m-1">
                      <small>QD / LT</small>
                      <strong className="d-block" style={{ fontSize: '13px' }}>
                        {item.quadra} / {item.lote}
                      </strong>
                    </li>
                  )}
                </ul>
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  <li className="m-1">
                    <small>Tipo Doc.</small>
                    <strong
                      className="d-block"
                      style={{
                        fontSize: '11px',
                      }}
                    >
                      {item.tipo_doc_digital}
                    </strong>
                  </li>

                  <li className="m-1">
                    <small>Solicitante</small>
                    <strong
                      className="d-block"
                      style={{
                        fontSize: 'smaller',
                      }}
                    >
                      {item.nome_solicitante}
                    </strong>
                  </li>
                  {item.assinatura_pendente !== null && (
                    <li className="m-1">
                      <small>Assinatura Pendente</small>
                      <strong
                        className="d-block"
                        style={{ fontSize: 'smaller' }}
                      >
                        {item.assinatura_pendente}
                      </strong>
                    </li>
                  )}
                </ul>
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left">
                  {item.grupo_pendente !== null && (
                    <li className="m-1">
                      <small>Grupo Pendente</small>
                      <strong className="d-block" style={{ fontSize: '11px' }}>
                        {item.grupo_pendente}
                      </strong>
                    </li>
                  )}
                </ul>
                <ul className="list-unstyled d-flex flex-wrap ImobiliariaItemResumo produtividade justify-content-between text-md-left mx-1">
                  <li
                    onClick={async () => {
                      let link = await montarLinkDocDigital(item.pre_venda);
                      if (link) {
                        window.open(link, '_blank');
                      }
                    }}
                  >
                    <strong>
                      <FaFileContract size={18} />
                    </strong>
                  </li>
                  <li
                    onClick={() => {
                      abrirModalDetalhes();
                    }}
                  >
                    <strong>
                      <FaSearch color="#0747a6" size={18} />
                    </strong>
                  </li>
                </ul>
              </Card>
            ))}
          <div className="d-flex justify-content-between mt-2 mb-2">
            <Pagination className="mb-0">
              <Pagination.First
                onClick={() => handlePageChange(1)}
                disabled={currentPage === 1}
              />
              <Pagination.Prev
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
              />

              {totalPages > 10 && currentPage > 5 && (
                <Pagination.Ellipsis className="ellipsis" />
              )}

              {[...Array(totalPages).keys()]
                .slice(
                  Math.max(0, currentPage - 1),
                  Math.min(totalPages, currentPage + 1)
                )
                .map(number => (
                  <Pagination.Item
                    key={number}
                    active={currentPage === number + 1}
                    onClick={() => handlePageChange(number + 1)}
                  >
                    {number + 1}
                  </Pagination.Item>
                ))}
              {totalPages > 10 && currentPage < totalPages - 4 && (
                <Pagination.Ellipsis className="ellipsis" />
              )}
              <Pagination.Next
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
              />
              <Pagination.Last
                onClick={() => handlePageChange(totalPages)}
                disabled={currentPage === totalPages}
              />
            </Pagination>
            <Button
              variant="success"
              disabled={realizandoDownload}
              onClick={async () => {
                setRealizandoDownload(true);
                await salvarEmExcel(
                  retornoApi,
                  '/exportador/excel/relatorio-documento-digital'
                );
                setRealizandoDownload(false);
              }}
            >
              <FaFileExcel />
              <span className="ml-2 ocultar-mobile">Salvar</span>
            </Button>
          </div>
          {mostrarModalDetalhes && (
            <ModalDetalhesDocDigital
              linhaSelecionada={selectedRow}
              mostrarModal={mostrarModalDetalhes}
              setMostrarModal={setMostrarModalDetalhes}
            />
          )}
        </div>
      )}
      {!loading && currentRecords.length === 0 && (
        <div className="text-center mt-4">
          <span>Nenhum resultado encontrado.</span>
        </div>
      )}
      {!temPermissao && (
        <div className="text-center">
          <label>Usuário sem permissão para acessar a tela.</label>
        </div>
      )}
    </div>
  );
};

export default ControleDocumentoDigital;
